import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import NoPreviewImage from 'assets/images/no-preview.jpg';

import './PDFViewer.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const pdfDocumentOptions = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
  isEvalSupported: false,
};

const DEFAULT_WIDTH = 466;
const DEFAULT_HEIGHT = 660;

const PDFPreview = ({ file, width, height }) => {
  const [numPages, setNumPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
  };

  return (
    <div className="pdf--container" style={{ height }}>
      <Document
        file={file}
        options={pdfDocumentOptions}
        onLoadSuccess={onDocumentLoadSuccess}
        noData={<img src={NoPreviewImage} alt="" width="100%" />}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            height={height || DEFAULT_HEIGHT}
            width={width || DEFAULT_WIDTH}
          />
        ))}
      </Document>
    </div>
  );
};

export default PDFPreview;
